import { render, staticRenderFns } from "./DragImgSingle.vue?vue&type=template&id=68028c58&scoped=true"
import script from "./DragImgSingle.vue?vue&type=script&lang=js"
export * from "./DragImgSingle.vue?vue&type=script&lang=js"
import style0 from "./DragImgSingle.vue?vue&type=style&index=0&id=68028c58&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68028c58",
  null
  
)

export default component.exports